module.exports = __webpack_public_path__ + "img/PT3470.9dcf25ec.png";